import { IChannelThemeState } from "../../types/channelTheme";

const initialState: IChannelThemeState = {};

export default function channelThemeReducer(
  state = initialState,
  action: any
): IChannelThemeState {
  switch (action.type) {
    case "SET_CHANNEL_THEME":
      console.log(`Setting theme for channel ${action.channelId}:`, action.payload);
      return {
        ...state,
        [action.channelId]: action.payload,
      };
    
    case "CLEAR_CHANNEL_THEME":
      console.log(`Clearing theme for channel ${action.channelId}`);
      const newState = { ...state };
      delete newState[action.channelId];
      return newState;
    
    case "CLEAR_ALL_CHANNEL_THEMES":
      console.log("Clearing all channel themes");
      return {};
    
    case "UPDATE_CHANNEL_THEME":
      // For partial theme updates
      return {
        ...state,
        [action.channelId]: {
          ...(state[action.channelId] || {}),
          ...action.payload,
        },
      };
    
    // Clear themes when user logs out or switches programs
    case "LOGOUT_USER":
    case "CLEAR_USER_DATA":
    case "RESET_PROGRAM_STATE":
      console.log("Clearing all themes due to user/program state reset");
      return {};
    
    default:
      return state;
  }
}